import { toPng, toJpeg } from "html-to-image";
import { saveAs } from "file-saver";

let fontEmbedCSSCache = null;

const getFontEmbedCSS = async () => {
  if (fontEmbedCSSCache) return fontEmbedCSSCache;

  try {
    const res = await fetch("https://fonts.cdnfonts.com/css/satoshi");
    const css = await res.text();

    // Convert font URLs to data URIs for embedding
    // Handle both quoted and unquoted URLs: url(...), url('...'), url("...")
    const urlRegex = /url\(['"]?(https?:\/\/[^'")\s]+)['"]?\)/g;
    const matches = [...css.matchAll(urlRegex)];

    let inlinedCSS = css;
    for (const match of matches) {
      const fontUrl = match[1];
      try {
        const fontRes = await fetch(fontUrl);
        const blob = await fontRes.blob();
        const dataUrl = await new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.readAsDataURL(blob);
        });
        inlinedCSS = inlinedCSS.replace(match[0], `url(${dataUrl})`);
      } catch (err) {
        console.warn(`Failed to fetch font: ${fontUrl}`, err);
      }
    }

    fontEmbedCSSCache = inlinedCSS;
    return inlinedCSS;
  } catch (err) {
    console.warn("Failed to fetch Satoshi font CSS", err);
    return "";
  }
};

// Pre-warm font cache on module load
getFontEmbedCSS();

export const captureImage = async (element, format = "png", { width, height } = {}) => {
  if (!element) throw new Error("No element provided for capture");

  const fontEmbedCSS = await getFontEmbedCSS();
  const captureFn = format === "jpg" ? toJpeg : toPng;

  const options = {
    pixelRatio: 1,
    cacheBust: true,
    fontEmbedCSS,
    quality: format === "jpg" ? 0.95 : undefined,
  };

  if (width && height) {
    options.width = width;
    options.height = height;
    options.style = {
      overflow: "visible",
      width: `${width}px`,
      height: `${height}px`,
    };
  }

  return captureFn(element, options);
};

export const downloadImage = async (element, filename, format = "png", { width, height } = {}) => {
  const dataUrl = await captureImage(element, format, { width, height });
  const res = await fetch(dataUrl);
  const blob = await res.blob();
  saveAs(blob, `${filename}.${format === "jpg" ? "jpg" : "png"}`);
};
